export class RemittancePurposeTypeCode {

  /**
   * The Constant SERVICING_REMT_CD.
   */
  static readonly  ACQUISITION_CODE = 0;
  static readonly  ACQUISITION_DESC = 'Acquisition';
  static readonly  ACQUISITION_LBL = 'ACQ';
  static readonly  SERVICING_DAILY_CODE = 1;
  static readonly  SERVICING_DAILY_DESC = 'Servicing Daily';
  static readonly  SERVICING_DAILY_LBL = 'SERV';
  static readonly  SCHEDULED_PAYMENT_MONTHLY_CODE = 2;
  static readonly  SCHEDULED_PAYMENT_MONTHLY_DESC = 'Scheduled Payment Monthly';
  static readonly  SCHEDULED_PAYMENT_MONTHLY_LBL = 'SCHPT';
  static readonly  MIP_SERVICE_FEE_MONTHLY_CODE = 3;
  static readonly  MIP_SERVICE_FEE_MONTHLY_DESC = 'MIP and Service Fee Monthly';
  static readonly  MIP_SERVICE_FEE_MONTHLY_LBL = 'MIPSF';
  static readonly  PURCHASE_ADJUSTMENTS_CODE = 4;
  static readonly  PURCHASE_ADJUSTMENTS_DESC = 'Purchase Adjustments';
  static readonly  PURCHASE_ADJUSTMENTS_LBL = 'PCHAJ';
  static readonly  PREMIUM_REVERSAL_CODE = 5;
  static readonly  PREMIUM_REVERSAL_DESC = 'Premium Reversal';
  static readonly  PREMIUM_REVERSAL_LBL = 'PREMP_REVL';
}
